export default __webpack_public_path__ + "static/Promo_Mobile-a0c925a154b99b9afc84e1052fd52fde.webp";